<div class="media-preview" [class.no-toolbar]="!showToolbar">

  <div class="media">

    @switch (selectedMediaType) {

    @case (MediaType.Image){
    <img [attr.src]="selectedMedia() || './../../assets/icons/start.svg'" alt="">

    <button class="btn btn-light btn-rounded copy-image" (click)="goToFullScreen()">
      <i class="bi bi-arrows-fullscreen"></i> </button>
    <!-- @if(selectedMedia()){
    <button class="btn btn-light btn-rounded copy-image" (click)="copyImageToClipboard()">
      <i class="bi bi-copy"></i>
    </button>
    } -->

    }

    @case(MediaType.Video){
    <app-video [video]="selectedVideo()"></app-video>
    }

    @case(MediaType.Model3D){
    <iframe [src]="selectedMedia()" frameborder="0"></iframe>
    }

    }

  </div>

  @if(showToolbar){
  <div class="toolbar">

    @if(canShowImageButton){
    <button class="btn btn-light" [class.selected]="selectedMediaType === MediaType.Image"
      (click)="handleSelectMediaType.emit(MediaType.Image)">
      <img src="assets/icons/photo.svg" alt="">
      <span>{{'Photo'|translate}}</span>
    </button>
    }

    @if(canShowVideoButton){
    <button class="btn btn-light" [class.selected]="selectedMediaType === MediaType.Video"
      (click)="handleSelectMediaType.emit(MediaType.Video)">
      <img src="assets/icons/video.svg" alt="">
      <span>{{'Video'|translate}}</span>
    </button>
    }

    @if(canShowModel3DButton){
    <button class="btn btn-light" [class.selected]="selectedMediaType === MediaType.Model3D"
      (click)="handleSelectMediaType.emit(MediaType.Model3D)">
      <img src="assets/icons/3d.svg" alt="">
      <span>{{'3D'|translate}}</span>
    </button>
    }
  </div>}

</div>
